import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { LoadingButton } from '../shared/ui/Buttons';
import { extraColor } from './muiTheme';

// All styled components related with Mui Button are moved here now.
// need to check inline style in buttons in other files.

export const CopyButton = styled(Button)`
  margin-top: 6px;
`;

export const DealsButton = styled(LoadingButton)({
  minHeight: 'auto',
  fontWeight: 600,
});


export const StyledSaveButton = styled(Button)<{ width?: string, minHeight?: string }>`
  width: ${({ width }) => width || '100px'};
  min-height: ${({minHeight}) => minHeight};
  background-color: ${extraColor.palette.green.main};
  opacity: 0.97;
  min-height: auto;
  &:hover {
    background-color: ${extraColor.palette.green.main};
    opacity: 1;
  }
`;

export const CancelButton = styled(Button)`
  opacity: 0.5;
  transition: opacity ease 0.3s;

  &:hover {
    opacity: 1;
  }
`;

export const SaveButtonWrapper = styled('div')<{ top?: string; right?: string, position? : string }>`
  display: flex;
  align-items: center;
  gap: 15px;
  top: ${({ top }) => top || '-120px'};
  right: ${({ right }) => right || 0};
  position: ${({ position }) => position || 'absolute'};
`;

export const SaveButtonDisplayMsg = styled('span')`
  font-size: 13px;
  color: ${({ theme }) => theme.palette.error.main};
  word-wrap: break-word;
`;


export const StyledFileNameButton = styled(Button)`
  text-align: left;
  padding: 0;
  white-space: normal;
  word-break: break-word; 
  font-size: 13px;
  font-weight: bold;
`;
